import React from "react";
import styled from "styled-components";

const ProductIndex = (props: any) => {
  const { title, number } = props;
  return (
    <Wrapper>
      <div className="section-center">
        <p className="filter-title">
          {title} ({number.toString()})
        </p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin: 44px auto 0;
  .filter-title {
    font-family: HelveticaNeue-Bold;
    font-size: 24px;
    color: #090a0a;
    margin-bottom: 0;
    text-transform: capitalize;
  }
`;

export default ProductIndex;
